import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Heading } from '@leroy-merlin-br/backyard-react-ui'

const sectionStyles = () => css`
  label: cta;

  padding: 70px 0;

  text-align: center;
`

const titleStyles = ({ theme }) => css`
  font-weight: ${theme.font.weight.regular};

  span {
    color: ${theme.colors.p500};
  }
`

export const Section = styled('section')(sectionStyles)
export const Title = styled(Heading)(titleStyles)
